import api from 'services/api'

import { GET_PANIC_QUERIES_LIST } from "../endpoints";


export const getPanicQueriesData = async (body) => await api.post(GET_PANIC_QUERIES_LIST, body)